import request from '../../../../api/request';
import { SelectOptionType } from '@octano/global-ui';
import type { ReportFormData, ReportAuditOfGradesFormData } from './type';

export const REPORT = {
  FORM_DATA: '/report/form',
  FORM_RESOURCES: '/report/resources',
  FORM_AUDIT_OF_GRADES_DATA: '/report/audit-of-grades/form',
};

export function getFormData() {
  return request<ReportFormData>(REPORT.FORM_DATA, {
    method: 'get',
  });
}
export function getResourcesData(resources: string[]) {
  return request<Record<string, SelectOptionType[]>>(REPORT.FORM_RESOURCES, {
    method: 'post',
    data: { resources },
  });
}

export function getAuditOfGradesFormData() {
  return request<ReportAuditOfGradesFormData>(REPORT.FORM_AUDIT_OF_GRADES_DATA);
}
